import { render } from "./tab-item.vue?vue&type=template&id=cde8bca4&scoped=true"
import script from "./tab-item.vue?vue&type=script&lang=js"
export * from "./tab-item.vue?vue&type=script&lang=js"

import "./tab-item.vue?vue&type=style&index=0&id=cde8bca4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde8bca4"]])

export default __exports__